import { render, staticRenderFns } from "./DemoSpaceship.vue?vue&type=template&id=274b840d&"
import script from "./DemoSpaceship.vue?vue&type=script&lang=js&"
export * from "./DemoSpaceship.vue?vue&type=script&lang=js&"
import style0 from "./DemoSpaceship.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports